import React, { CSSProperties, FunctionComponent, ReactElement, ReactNode } from 'react';

import { css } from 'emotion';

const verticalDict = {
    baseline: 'baseline',
    bottom: 'flex-end',
    middle: 'center',
    top: 'flex-start'
};

const horizontalDict = {
    between: 'space-between',
    center: 'center',
    left: 'flex-start',
    right: 'flex-end'
};

const directionDict = {
    column: 'column',
    row: 'row'
};

type Direction = keyof typeof directionDict;
type Horizontal = keyof typeof horizontalDict;
type Vertical = keyof typeof verticalDict;

export interface IFlexProps {
    children?: ReactNode;
    direction?: Direction;
    flex?: string;
    fullHeight?: boolean;
    fullWidth?: boolean;
    grow?: number;
    horizontal?: Horizontal;
    multiLine?: boolean;
    onClick?: () => void;
    style?: CSSProperties;
    vertical?: Vertical;
}

const Flex: FunctionComponent<IFlexProps> = (props): ReactElement => {
    const {
        children,
        direction = 'row',
        fullHeight,
        fullWidth,
        horizontal = 'center',
        multiLine,
        vertical = 'top',
        grow,
        flex,
        style,
        onClick,
    } = props;

    return (
        <div
            className={css`
                align-items: ${verticalDict[vertical]};
                display: flex;
                ${flex && `flex: ${flex};`}
                flex-direction: ${directionDict[direction]};
                ${grow && `flex-grow: ${grow};`}
                flex-wrap: ${multiLine ? 'wrap' : 'nowrap'};
                ${(fullHeight && 'height: 100%;') || ''}
                justify-content: ${horizontalDict[horizontal]};
                margin: 0;
                padding: 0;
                ${(fullWidth && 'width: 100%;') || ''}
            `}
            style={style}
            onClick={onClick}
        >
            {children}
        </div>
    );
};

export default Flex;
